export function CellStatusIndicator(props: { color: string; count?: number }) {
  let color = '';
  if (props.color === 'red') {
    color = '#f5222d';
  } else if (props.color === 'gold') {
    color = '#faad14';
  } else if (props.color === 'blue') {
    color = '#1890ff';
  } else if (props.color === 'purple') {
    color = '#722ed1';
  } else if (props.color === 'gray') {
    color = '#6d6d6d';
  } else if (props.color === 'lime') {
    color = '#a0d911';
  } else if (props.color === 'magenta') {
    color = '#780650';
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: color,
        height: '1rem',
        paddingLeft: '2px',
        paddingRight: '2px',
        margin: '0 2px',
        color: '#ffffff',
        fontSize: '0.6rem',
        fontWeight: 'bold',
      }}
    >
      {props.count || null}
    </div>
  );
}
